/**
 * System Questionnaires - Speech Therapist (קלינאות תקשורת)
 *
 * Read-only questionnaires specific to speech therapy clinics.
 * Field types: short_text, long_text, checkbox
 */

export const speechTherapistQuestionnaires = [
  {
    id: "sys_quest_st_anamnesis",
    name: "שאלון אנמנזה - קלינאות תקשורת",
    fields: [
      // פרטי הילד/ה
      { id: "sq_a_01", type: "short_text", label: "שם הילד/ה", required: true },
      { id: "sq_a_02", type: "short_text", label: "תאריך לידה", required: true },
      { id: "sq_a_03", type: "short_text", label: "שם ההורה הממלא/ת", required: true },
      { id: "sq_a_04", type: "short_text", label: "קרבה לילד/ה", required: true },
      { id: "sq_a_05", type: "short_text", label: "מסגרת חינוכית (שם ושנתון)", required: false },

      // הריון ולידה
      { id: "sq_a_06", type: "long_text", label: "תארו בקצרה את מהלך ההריון (תקין / סיבוכים / תרופות)", required: false },
      { id: "sq_a_07", type: "short_text", label: "סוג הלידה (רגילה / ניתוח קיסרי / מכשירנית)", required: false },
      { id: "sq_a_08", type: "short_text", label: "משקל בלידה", required: false },
      { id: "sq_a_09", type: "checkbox", label: "האם היו סיבוכים בלידה או לאחריה?", required: false },
      { id: "sq_a_10", type: "long_text", label: "אם כן, פרטו", required: false },

      // התפתחות מוטורית
      { id: "sq_a_11", type: "short_text", label: "גיל ישיבה עצמאית (בחודשים)", required: false },
      { id: "sq_a_12", type: "short_text", label: "גיל הליכה עצמאית (בחודשים)", required: false },
      { id: "sq_a_13", type: "checkbox", label: "האם יש/היו קשיים מוטוריים (עדינים או גסים)?", required: false },
      { id: "sq_a_14", type: "long_text", label: "אם כן, פרטו על הקשיים המוטוריים", required: false },

      // התפתחות שפה ודיבור
      { id: "sq_a_15", type: "short_text", label: "גיל מילים ראשונות (בחודשים)", required: false },
      { id: "sq_a_16", type: "short_text", label: "גיל צירופי מילים / משפטים (בחודשים)", required: false },
      { id: "sq_a_17", type: "long_text", label: "תארו את רמת הדיבור הנוכחית (בהירות, אוצר מילים, בניית משפטים)", required: true },
      { id: "sq_a_18", type: "checkbox", label: "האם הסביבה מבינה את דיבורו/ה של הילד/ה?", required: false },
      { id: "sq_a_19", type: "long_text", label: "האם יש קשיים בהבנת הוראות או שיחה? תארו", required: false },
      { id: "sq_a_20", type: "short_text", label: "אילו שפות מדוברות בבית?", required: true },
      { id: "sq_a_21", type: "short_text", label: "מהי השפה הדומיננטית של הילד/ה?", required: false },

      // שמיעה
      { id: "sq_a_22", type: "checkbox", label: "האם הילד/ה עבר/ה בדיקת שמיעה?", required: false },
      { id: "sq_a_23", type: "short_text", label: "תאריך בדיקת השמיעה האחרונה", required: false },
      { id: "sq_a_24", type: "short_text", label: "תוצאות בדיקת השמיעה", required: false },
      { id: "sq_a_25", type: "checkbox", label: "האם יש/היו דלקות אוזניים חוזרות?", required: false },
      { id: "sq_a_26", type: "checkbox", label: "האם הוכנסו צינוריות באוזניים?", required: false },

      // האכלה ובליעה
      { id: "sq_a_27", type: "long_text", label: "תארו את הרגלי האכילה (בררנות, קשיים בלעיסה/בליעה, מרקמים מועדפים)", required: false },
      { id: "sq_a_28", type: "checkbox", label: "האם ישנה נשימת פה או נחירות בשינה?", required: false },
      { id: "sq_a_29", type: "checkbox", label: "האם הילד/ה משתמש/ת במוצץ או מוצץ אצבע?", required: false },

      // רקע רפואי
      { id: "sq_a_30", type: "long_text", label: "אבחנות רפואיות ידועות (אם ישנן)", required: false },
      { id: "sq_a_31", type: "long_text", label: "תרופות קבועות (אם ישנן)", required: false },
      { id: "sq_a_32", type: "checkbox", label: "האם יש רקע משפחתי של קשיי שפה, דיבור, שמיעה או למידה?", required: false },
      { id: "sq_a_33", type: "long_text", label: "אם כן, פרטו על הרקע המשפחתי", required: false },

      // טיפולים נוכחיים
      { id: "sq_a_34", type: "long_text", label: "טיפולים נוכחיים או קודמים (ריפוי בעיסוק, פסיכולוגיה, וכד׳)", required: false },
      { id: "sq_a_35", type: "checkbox", label: "האם הילד/ה קיבל/ה טיפול בקלינאות תקשורת בעבר?", required: false },
      { id: "sq_a_36", type: "long_text", label: "אם כן, היכן, כמה זמן ומה היו המטרות?", required: false },

      // התנהגות ותפקוד חברתי
      { id: "sq_a_37", type: "long_text", label: "תארו את ההתנהגות הכללית (ריכוז, שיתוף פעולה, תסכול)", required: false },
      { id: "sq_a_38", type: "long_text", label: "תארו את התפקוד החברתי (קשר עם ילדים, משחק, יזמת אינטראקציה)", required: false },

      // ציפיות
      { id: "sq_a_39", type: "long_text", label: "מהן הדאגות העיקריות שלכם לגבי השפה/דיבור של הילד/ה?", required: true },
      { id: "sq_a_40", type: "long_text", label: "מהן הציפיות שלכם מהתהליך הטיפולי?", required: false },
      { id: "sq_a_41", type: "long_text", label: "האם יש משהו נוסף שחשוב לכם שנדע?", required: false },
    ],
    isSystem: true,
    clinicTypes: ["speech_therapist"],
    category: "intake",
  },
];
